export const readOnlyFileQuery = async ({ publicClient, id }) => {
  const { data } = await publicClient.get(`/public/files/${id}/`);
  return data;
};
